import React, { useState } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { createProduct, showProduct } from '~/config/routes';
import Request from '~/providers/Request';
import ProductRecord from '~/records/ProductRecord';
import Form from './Form';
import { toast } from 'react-toastify';
import _ from 'lodash';

function NewRecord({ history }) {
  const [record, setRecord] = useState(new ProductRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit(saveAndContinue) {
    const data = _.cloneDeep(record.toParams());

    if (!data.data.attributes.name) {
      toast.error('Nome é obrigatório');
      return;
    } else if (data.data.attributes.name.length < 3) {
      toast.error('Nome deve ter pelo menos 3 caracteres');
      return;
    }

    Request.post('/admin/products', data, {}, { controller: 'products' })
      .then((resp) => {
        setLoading(false);
        if (saveAndContinue) {
          history.push(createProduct.spec);
          toast.success('Produto criado com sucesso!');
        } else {
          history.push(showProduct.reverse(resp.data));
          toast.success('Produto criado com sucesso!');
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
        toast.error('Erro ao criar produto!');
      });
  }

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes = {
  history: historyPropType,
};

export default NewRecord;
